import ThemeOptions from './ThemeOptions';

/* export default {
  ThemeOptions
}; */

export default {
  ThemeOptions
};
